<template>
    <div class="tw:relative">
        <!-- Loading overlay -->
        <div v-if="loading" class="tw:absolute tw:inset-0 tw:bg-white/50 tw:z-10 tw:flex tw:items-center tw:justify-center tw:transition-opacity">
            <svg class="tw:animate-spin tw:h-8 tw:w-8 tw:text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="tw:opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                <path class="tw:opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
            </svg>
        </div>
        <div class="tw:overflow-x-auto tw:sm:overflow-x-hidden tw:rounded-md tw:border tw:border-slate-200">
            <table class="simple-table tw:w-full tw:border-collapse tw:text-sm">
                <thead class="tw:bg-slate-50 tw:text-[10px] tw:font-bold tw:uppercase tw:tracking-[0.075em] tw:text-slate-400">
                    <tr>
                        <th v-for="col in columns" :key="col.key"
                            :class="['tw:px-4 tw:py-2 tw:font-semibold', col.align === 'right' ? 'tw:text-right' : col.align === 'center' ? 'tw:text-center' : 'tw:text-left']"
                        >
                            {{ col.label }}
                        </th>
                    </tr>
                </thead>
                <tbody class="tw:divide-y tw:divide-slate-100">
                    <tr v-for="(row, idx) in data" :key="row.id || idx"
                        :class="rowClass ? rowClass(row, idx) : 'tw:bg-white tw:hover:bg-slate-50 tw:transition-colors tw:duration-150'"
                        @click="onRowClick(row, idx)"
                    >
                        <td v-for="col in columns" :key="col.key"
                            :class="['tw:px-4 tw:py-3', col.align === 'right' ? 'tw:text-right' : col.align === 'center' ? 'tw:text-center' : 'tw:text-left']"
                        >
                            <slot :name="`cell-${col.key}`" :row="row" :value="row[col.key]">
                                {{ row[col.key] ?? '—' }}
                            </slot>
                        </td>
                    </tr>
                    <tr v-if="!data.length && !loading">
                        <td :colspan="columns.length" class="tw:px-4 tw:py-10 tw:text-center tw:text-gray-400">
                            {{ emptyText }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script setup>
    import { t } from '@/utils/i18n-helper';

    const props = defineProps({
        columns:   { type: Array, required: true },
        data:      { type: Array, default: () => [] },
        loading:   { type: Boolean, default: false },
        emptyText: { type: String, default: t('perfil.sin_plazos') },
        rowClass:  { type: Function, default: null },
    });

    const emit = defineEmits(['row-click']);

    const onRowClick = (row, idx) => {
        emit('row-click', row, idx);
    };
</script>

<style scoped>
@media (max-width: 767px) {
    .simple-table {
        min-width: 480px;
    }
}
</style>
